<template>
<div>
  <!-- 基础信息 -->
    <a-card class="card" :bordered="false" :activeon="activeon">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="物流基本信息" v-if="mdl">
        <detail-list-item term="物流单号">{{ mdl.logisticsNo }}</detail-list-item>
        <detail-list-item term="车号">{{ mdl.vehicleNo }}</detail-list-item>
        <detail-list-item term="业务类型">{{ mdl.businessTypeId }}</detail-list-item>
        <detail-list-item term="物流状态">{{ mdl.logStatus }}</detail-list-item>
        <detail-list-item term="供应商">{{ mdl.supplierName }}</detail-list-item>
        <detail-list-item term="驾驶员">{{ mdl.driverName }}</detail-list-item>
        <detail-list-item term="手机号">{{ mdl.phone }}</detail-list-item>
        <detail-list-item term="押运员">{{ mdl.escortId }}</detail-list-item>
        <detail-list-item term="创建时间">{{mdl.createTime | formatDate}}</detail-list-item>
      </detail-list>

      <a-table
        size="small"
          :bordered="config.globlaBordered"
          :rowKey="(record, index) => index"
          :columns="orderColumns"
          :dataSource="orderList"
          :pagination="false"
        >
      </a-table>
    </a-card>
  
<!-- 节点信息 -->
    <a-card class="card" :bordered="false">
      <template>
        <div class="step-div">
          <a-steps ref="stepbox" id="stepbox" class="stepbox" progressDot direction="vertical" :current="current">
            <a-step v-for="item in steps" :key="item.value" >
              <template slot="title">
                <a @click="showContent(item.value)">{{item.name}}</a>
              </template>
              <span v-if="item.createTime" slot="description">{{item.createTime | formatDate}}</span>
              <span v-if="!item.createTime" slot="description"></span>
            </a-step>
          </a-steps>
          <div ref="stepscontent" id="stepscontent" class="steps-content" v-html="contstr">{{contstr}}</div>
        </div>
      </template>
    </a-card>

<!-- 物流日志 -->
    <a-card class="card" title="物流日志">
      <template>
        <div class="log-div" v-for="item in logisticsLog" :key="item.value">
          <div class="log-div-title">{{item.statusName}}</div>
          <div class="log-div-cont">
            <div class="log-div-remark">{{item.remark}}</div>
            <div class="log-div-time">{{item.createTime | formatDate}}</div>
          </div>
        </div>
      </template>
    </a-card>
</div>
</template>


<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import { getLogStatusTextByValue, getBizTextByValue } from '@/utils/util'
import { logisticsFindLogisticsInfoData } from '@/api/logistics'
import { formatDate } from '@/utils/date'
import { getTextByTypeAndValue } from '@/utils/util'
import storage from "@/utils/storage"

const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null,
      current: 0,
      steps: [],
      LogisticsInfoData: {},
      contstr: '',  // 用于拼接节点图右侧的内容区域
      activeon: 1,
      logisticsLog: [],  // 物流日志
      orderList:[],
      orderColumns: [
          {
            title: '物料名称',
            dataIndex: 'materielName',
            key: 'materielName',
          },
          {
            title: '订单号',
            dataIndex: 'orderNo',
            key: 'orderNo',
          },
          {
            title: '剩余量(吨)',
            dataIndex: 'residueQuantity',
            key: 'residueQuantity',
          },
          {
            title: '预约量(吨)',
            dataIndex: 'predictQuantity',
            key: 'predictQuantity',
          },
        ],
    }
  },
  mounted () {
    this.initData()
  },
  watch: {
    steps: function() {
      this.$nextTick(function() {
        // 动态内容框的高度
        this.$refs.stepscontent.style.height = document.getElementById("stepbox").offsetHeight + 'px'
        // 用于兼容物流状态未在节点内的情况
        this.current = this.steps.length - 1
        for (let i = 0; i < this.steps.length; i++) {
          const element = this.steps[i]
          if (element.value == this.mdl.status) {
            this.current = i
          }
        }
      });
    }
  },
  filters: {
    formatDate (value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    initData () {
      let weightCache = storage.fetch("cache-LogisticsDetail");
      if (weightCache){
          this.mdl = JSON.parse(weightCache);
          this.materielList = this.mdl.materielList
          for (let i = 0; i<this.materielList.length;i++){
            let materiel = this.materielList[i]
            for (let i = 0; i<materiel.orderList.length;i++){
              materiel.orderList[i].materielName = materiel.materielName
              this.orderList.push(materiel.orderList[i])
            }
          }
      } 
      // this.mdl = JSON.parse(this.$route.query.datas)
      this.bizList = this.$store.getters.bizList
      this.mdl.logStatus = getLogStatusTextByValue(this.$store.getters.bizCodeList, this.mdl.businessTypeId, this.mdl.logStatus)
      this.mdl.businessTypeId = getBizTextByValue(this.$store.getters.bizList, this.mdl.businessTypeId)

      new Promise(resolve => {
        const data = logisticsFindLogisticsInfoData({'logisticsNo': this.mdl.logisticsNo}).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.steps = res.statusAll
        this.current = this.steps.length - 1
        this.LogisticsInfoData = res
        this.logisticsLog = res.logisticsLog
        this.showContent (this.mdl.status)
      })
    },
    showContent (nodeValue) {
      if (nodeValue <= this.mdl.status) {
        // 处理‘已完成’状态的情况，设置声其上一个节点
        if (nodeValue == '999') {
          for (let i = this.steps.length - 1; i >= 0; i--) {
            const element = this.steps[i]
            if (element.value != '999' && nodeValue == '999') {
              nodeValue = element.value
            }
          }
        }
        // 每次拼装前清空旧的内容
        this.contstr = ''
        // 定义存放内容数据的对象
        let obj
        // 拼装内容区域
        switch (nodeValue) {
          case '010':  // 预约
            obj = this.LogisticsInfoData['010']
            this.contItem('预约号', obj.reservationNo)
            this.contItem('验证码', obj.verificationCode)
            if (obj.appointedDate != null) {
              this.contItem('上门时间', formatDate(new Date(obj.appointedDate), 'yyyy-MM-dd hh:mm:ss'))
            } else {
              this.contItem('上门时间', '')
            }
            this.contItem('身份证号', obj.idcard)
            this.contItem('审核状态', getTextByTypeAndValue(this.$store.getters.codeList, this.config.TYPE_CODE.LOGISTICS_RESERVATION_STATUS, obj.status ))
            if (obj.auditDate != null) {
              this.contItem('审核时间', formatDate(new Date(obj.auditDate), 'yyyy-MM-dd hh:mm:ss'))
            } else {
              this.contItem('审核时间', '')
            }
            break;
          case '020':  // 发卡
            const gclist = this.LogisticsInfoData['020']
            for (let i = 0; i < gclist.length; i++) {
              obj = gclist[i];
              this.contItem('发卡单号', obj.grantCardNo)
              this.contItem('卡号', obj.cardNo)
              this.contItem('车号', obj.vehicleNo)
              this.contItem('驾驶员', obj.driverName)
              this.contItem('状态', obj.statusName)
              this.contItem('卡类型', obj.cardTypeName)
              this.contItem('发卡时间', formatDate(new Date(obj.createTime), 'yyyy-MM-dd hh:mm:ss'))
              if (i < gclist.length - 1) 
                this.contHr()
            }
            break;
          case '030':  // 排队
            for (let i = 0; i < this.steps.length; i++) {
              const zz = this.steps[i]
              if (zz.value == '030') {
                this.contItem(null, '车辆于' + formatDate(new Date(zz.createTime), 'yyyy年MM月dd日 hh:mm:ss') + '在排队', '100%')
              }
            }
            break;
          case '040':  // 入厂
            const gclist040 = this.LogisticsInfoData['040']
            for (let i = 0; i < gclist040.length; i++) {
              obj = gclist040[i];
              this.contItem('物流单号', obj.logisticsNo)
              this.contItem('车号', obj.vehicleNo)
              this.contItem('抓拍车号', obj.discernVehicleNo)
              this.contItem('印刷卡号', obj.cardNo)
              this.contItem('ID卡号', obj.cardIdNo)
              this.contItem('IC卡号', obj.cardIcNo)
              this.contItem('进厂时间', formatDate(new Date(obj.inTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('进厂类型', obj.inTypeName)
              this.contItem('进厂门禁号', obj.inDoorCode)
              this.contItem('进厂通道', obj.inAisle)
              this.contItem('进厂操作人', obj.inUserName)
              this.contItem('进厂图片', obj.inImg)
              this.contItem('备注', obj.remark)
              if (i < gclist040.length - 1) 
                this.contHr()
            }
            break;
          case '050':  // 一次过磅
            const gclist050 = this.LogisticsInfoData['050']
            for (let i = 0; i < gclist050.length; i++) {
              obj = gclist050[i];
              this.contItem('物流单号', obj.logisticsNo)
              this.contItem('称重单号', obj.weighingNo)
              this.contItem('卡号', obj.cardNo)
              this.contItem('创建时间', formatDate(new Date(obj.createTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('货物名称', obj.materielName)
              this.contItem('预约量', obj.predictQuantity)
              this.contItem('皮重', obj.tare)
              this.contItem('毛重', obj.gross)
              this.contItem('净重', obj.net)
              this.contItem('扣杂', obj.deductOne)
              this.contItem('扣杂类型', obj.deductOneType)
              this.contItem('扣杂2', obj.deductTwo)
              this.contItem('扣杂类型2', obj.deductTwoType)
              this.contItem('实重', obj.factOne)
              this.contItem('实重2', obj.factTwo)
              this.contItem('皮重称台', obj.tareScale)
              this.contItem('毛重称台', obj.grossScale)
              this.contItem('皮重时间', formatDate(new Date(obj.tareTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('毛重时间', formatDate(new Date(obj.grossTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('皮重操作人', obj.tareUserId)
              this.contItem('毛重操作人', obj.grossUserId)
              this.contItem('皮重抓拍车牌', obj.tareLpr)
              this.contItem('毛重抓拍车牌', obj.grossLpr)
              this.contItem('皮重数据来源', obj.tareFrom)
              this.contItem('毛重数据来源', obj.grossFrom)
              this.contItem('皮重数据采集说明', obj.tareExplain)
              this.contItem('毛重数据采集说明', obj.grossExplain)
              this.contItem('打印次数', obj.printCount)
              this.contItem('是否需要上传', obj.needUpload)
              this.contItem('件数', obj.pieceCount)
              this.contItem('重量-件数转换公式', obj.weighingToPiece)
              this.contItem('备注', obj.remark)
              this.contItem('货物单价', obj.materielPrice)
              this.contItem('运费单价', obj.freightPrice)
              this.contItem('货物金额', obj.materielMoney)
              this.contItem('运费金额', obj.freightMoney)
              this.contItem('过磅次数', obj.weighCount)
              this.contItem('第一次过磅时间', formatDate(new Date(obj.beginTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('第二次过磅时间', formatDate(new Date(obj.endTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('车牌对比描述(一次过磅)', obj.beginDesc)
              this.contItem('车牌对比描述(二次过磅)', obj.endDesc)
              if (i < gclist050.length - 1) 
                this.contHr()
            }
            break;
          case '060':  // 化验
            const gclist060 = this.LogisticsInfoData['060']
            for (let i = 0; i < gclist060.length; i++) {
              obj = gclist060[i];
              this.contItem('操作类型', obj.insType == '101' ? '新增' : obj.insType == '102' ? '修改' : obj.insType == '103' ? '删除' : '未知' )
              this.contItem('物流单号', obj.logisticsNo)
              this.contItem('卡号', obj.cardNo)
              this.contItem('车牌号', obj.carlicence)
              this.contItem('Al<sub>2</sub>O<sub>3</sub>', obj.al2o3)
              this.contItem('收到基灰分', obj.ash)
              this.contItem('干基灰分', obj.dAsh)
              this.contItem('干基发热量', obj.dHeat)
              this.contItem('干基硫', obj.dS)
              this.contItem('干基挥发分', obj.dVC)
              this.contItem('CaO', obj.cao)
              this.contItem('Fe<sub></sub>O<sub>3</sub>', obj.fe2o3)
              this.contItem('收到基低位热值', obj.heat)
              this.contItem('MgO', obj.mgO)
              this.contItem('SiO<sub>2</sub>', obj.siO2)
              this.contItem('收到基硫', obj.spercent)
              this.contItem('收到基挥发分', obj.vC)
              this.contItem('全水分', obj.wet)
              this.contItem('日期', obj.date)
              this.contItem('采样开始时间', obj.decTimeBegin)
              this.contItem('采样结束时间', obj.decTimeEnd)
              this.contItem('罐号', obj.num)
              this.contItem('供应商', obj.provider)
              this.contItem('是否合格', obj.result == '0' ? '不合格' : obj.result == '1' ? '合格' : '未知')
              if (i < gclist060.length - 1) 
                this.contHr()
            }
            break;
          case '070':  // 开始装卸货
            const gclist070 = this.LogisticsInfoData['070']
            for (let i = 0; i < gclist070.length; i++) {
              obj = gclist070[i];
              this.contItem('物流单号', obj.logisticsNo)
              this.contItem('装卸货单号', obj.loadWehicleNo)
              this.contItem('车牌号', obj.vehicleNo)
              this.contItem('类型', obj.typeName)
              this.contItem('货物名称', obj.materielName)
              this.contItem('装卸货点', obj.loadName)
              this.contItem('装卸货口', obj.loadPortCode)
              this.contItem('开始时间"', formatDate(new Date(obj.startTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('结束时间', formatDate(new Date(obj.endTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('装卸车人', obj.loadUserName)
              this.contItem('补货（补包）数', obj.replenishCount)
              this.contItem('退货（退包）数', obj.quitCount)
              this.contItem('冲包数', obj.clashCount)
              this.contItem('装卸货量', obj.cargoQuantity)
              this.contItem('卸货扣杂', obj.deduct)
              this.contItem('状态', obj.statusName)
              this.contItem('备注', obj.remark)
              if (i < gclist070.length - 1) 
                this.contHr()
            }
            break;
          case '080':  // 结束装卸货
            const gclist080 = this.LogisticsInfoData['070']
            for (let i = 0; i < gclist080.length; i++) {
              obj = gclist080[i];
              this.contItem('物流单号', obj.logisticsNo)
              this.contItem('装卸货单号', obj.loadWehicleNo)
              this.contItem('车牌号', obj.vehicleNo)
              this.contItem('类型', obj.typeName)
              this.contItem('货物名称', obj.materielName)
              this.contItem('装卸货点', obj.loadName)
              this.contItem('装卸货口', obj.loadPortCode)
              this.contItem('开始时间"', formatDate(new Date(obj.startTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('结束时间', formatDate(new Date(obj.endTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('装卸车人', obj.loadUserName)
              this.contItem('补货（补包）数', obj.replenishCount)
              this.contItem('退货（退包）数', obj.quitCount)
              this.contItem('冲包数', obj.clashCount)
              this.contItem('装卸货量', obj.cargoQuantity)
              this.contItem('卸货扣杂', obj.deduct)
              this.contItem('状态', obj.statusName)
              this.contItem('备注', obj.remark)
              if (i < gclist080.length - 1) 
                this.contHr()
            }
            break;
          case '090':  // 二次过磅
            const gclist090 = this.LogisticsInfoData['050']
            for (let i = 0; i < gclist090.length; i++) {
              obj = gclist090[i];
              this.contItem('物流单号', obj.logisticsNo)
              this.contItem('称重单号', obj.weighingNo)
              this.contItem('卡号', obj.cardNo)
              this.contItem('创建时间', formatDate(new Date(obj.createTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('货物名称', obj.materielName)
              this.contItem('预约量', obj.predictQuantity)
              this.contItem('皮重', obj.tare)
              this.contItem('毛重', obj.gross)
              this.contItem('净重', obj.net)
              this.contItem('扣杂', obj.deductOne)
              this.contItem('扣杂类型', obj.deductOneType)
              this.contItem('扣杂2', obj.deductTwo)
              this.contItem('扣杂类型2', obj.deductTwoType)
              this.contItem('实重', obj.factOne)
              this.contItem('实重2', obj.factTwo)
              this.contItem('皮重称台', obj.tareScale)
              this.contItem('毛重称台', obj.grossScale)
              this.contItem('皮重时间', formatDate(new Date(obj.tareTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('毛重时间', formatDate(new Date(obj.grossTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('皮重操作人', obj.tareUserId)
              this.contItem('毛重操作人', obj.grossUserId)
              this.contItem('皮重抓拍车牌', obj.tareLpr)
              this.contItem('毛重抓拍车牌', obj.grossLpr)
              this.contItem('皮重数据来源', obj.tareFrom)
              this.contItem('毛重数据来源', obj.grossFrom)
              this.contItem('皮重数据采集说明', obj.tareExplain)
              this.contItem('毛重数据采集说明', obj.grossExplain)
              this.contItem('打印次数', obj.printCount)
              this.contItem('是否需要上传', obj.needUpload)
              this.contItem('件数', obj.pieceCount)
              this.contItem('重量-件数转换公式', obj.weighingToPiece)
              this.contItem('备注', obj.remark)
              this.contItem('货物单价', obj.materielPrice)
              this.contItem('运费单价', obj.freightPrice)
              this.contItem('货物金额', obj.materielMoney)
              this.contItem('运费金额', obj.freightMoney)
              this.contItem('过磅次数', obj.weighCount)
              this.contItem('第一次过磅时间', formatDate(new Date(obj.beginTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('第二次过磅时间', formatDate(new Date(obj.endTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('车牌对比描述(一次过磅)', obj.beginDesc)
              this.contItem('车牌对比描述(二次过磅)', obj.endDesc)
              if (i < gclist090.length - 1) 
                this.contHr()
            }
            break;
          case '100':  // 发卡
            const gclist100 = this.LogisticsInfoData['100']
            for (let i = 0; i < gclist100.length; i++) {
              obj = gclist100[i];
              this.contItem('收卡单号', obj.grantCardNo)
              this.contItem('卡号', obj.cardNo)
              this.contItem('车号', obj.vehicleNo)
              this.contItem('驾驶员', obj.driverName)
              this.contItem('状态', obj.statusName)
              this.contItem('卡类型', obj.cardTypeName)
              this.contItem('收卡时间', formatDate(new Date(obj.createTime), 'yyyy-MM-dd hh:mm:ss'))
              if (i < gclist100.length - 1) 
                this.contHr()
            }
            break;
          case '110':  // 打印磅单
            for (let i = 0; i < this.steps.length; i++) {
              const zz = this.steps[i]
              if (zz.value == '110') {
                this.contItem(null, '车辆于' + formatDate(new Date(zz.createTime), 'yyyy年MM月dd日 hh:mm:ss') + '打印了磅单', '100%')
              }
            }
            break;
          case '120':  // 出厂
            const gclist120 = this.LogisticsInfoData['120']
            for (let i = 0; i < gclist120.length; i++) {
              obj = gclist120[i];
              this.contItem('物流单号', obj.logisticsNo)
              this.contItem('车号', obj.vehicleNo)
              this.contItem('抓拍车号', obj.discernVehicleNo)
              this.contItem('印刷卡号', obj.cardNo)
              this.contItem('ID卡号', obj.cardIdNo)
              this.contItem('IC卡号', obj.cardIcNo)
              this.contItem('车辆逻辑类型', obj.logicTypeName)
              this.contItem('出厂时间', formatDate(new Date(obj.outTime), 'yyyy-MM-dd hh:mm:ss'))
              this.contItem('出厂门禁号', obj.outDoorCode)
              this.contItem('出厂通道', obj.outAisle)
              this.contItem('出厂操作人', obj.outUserName)
              this.contItem('备注', obj.remark)
              if (i < gclist120.length - 1) 
                this.contHr()
            }
            break;
          default:
            break;
        }
      } 
    },
    contItem (labelStr, itemContStr, width, height) {
      width = width == null ? '49%' : width
      labelStr = labelStr == null ? '' : labelStr + '：'
      itemContStr = itemContStr == null ? '' : itemContStr
      this.contstr +='<div class="cont-item" ' +
      'style="width: ' + width + '; height: ' + height + '; float: left; background: #FFF; padding-top: 3px; padding-left: 13px; padding-bottom: 3px; text-align: left; border-radius: 5px;"' +
      '><label>' + labelStr + '</label>' + itemContStr + '</div>' 
    },
    contHr (){
      this.contstr += '<div class="cont-item" ' +
      'style="width: 100%; float: left; background: rgb(240, 240, 240); padding: 3px; text-align: left;"' +
      '><hr/></div>' 
    }
  }
}
</script>
<style lang="less" scoped>
  .card{
    margin-bottom: 24px;
  }
  .stepbox {
    // border: solid 1px #000;
    width: 25%;
    float: left;
  }
  .steps-content {
    text-align: center;
    // border: solid 1px #090;
    width: 75%;
    float: left;
    border-radius: 5px;
    background-color: rgb(240, 240, 240);
    padding: 0.5%;
    overflow-y: auto;
  }
  .cont-item {
    border: solid 3px #000;
    float: left;
    background: #FFF;
    padding-top: 3px;
    padding-bottom: 3px;
    text-align: center;
  }
  .log-div{
    border: double 2px #bbb;
    width: 23%;
    float: left;
    border-radius: 5px;
    margin: 6px;
  }
  .log-div .log-div-title {
    border-bottom: double 1px #ccc;
    padding: 3px;
    padding-left: 8px;
    text-align: center;
    background-color: #efefef;
  }
  .log-div .log-div-cont>div {
    padding: 3px;
    padding-left: 8px;
  }
</style>